// Destino "home" pós-login por papel do usuário.
// Fonte única de verdade reutilizada no login, no GuestRoute e em redirects.
export function getHomePathForRole({ isAdmin, isPaid } = {}) {
  if (isAdmin) return "/admin";
  if (isPaid) return "/dashboard";
  return "/buy";
}
